import CustomSelect from '../../../form/custom-select';
import Observer from '@/common/scripts/observer';
import tmplFlatsList from '../flat/templates/flat-list.twig';
import tmplNoResults from './templates/noresults.twig';
import tmplPantryist from '../flat/templates/pantry-list.twig';
import tmplParkingList from '../flat/templates/parking-list.twig';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class ParametricResult {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        /**
         * Целевой элемент
         */
        this.element = options.element ? options.element.querySelector('.j-parametric-result') : null;

        /**
         * CSS-класс состояния загрузки
         * @type {string}
         */
        this.loadingClass = 'is-loading';
        this.activeClass = 'is-active';
        this.processClass = 'is-process';
        this.debTime = 150;
        this.page = 1;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._bindContext();
        this._initElements();
        this._initSelects();
        this._bindEvents();
    }

    /**
     * Запуск состояния загрузки
     */
    runLoading() {
        this.element.classList.add(this.loadingClass);
    }

    /**
     * Отмена состояния загрузки
     */
    stopLoading() {
        this.element.classList.remove(this.loadingClass);
    }

    /**
     * Обновляет результаты выдачи после поиска
     * @param {object} data - данные с сервера
     */
    setResult(data) {
        this._setNoResults(data.noResults);
        this.setFlatsList(data.premises, true);
        this.setMoreButton(data.pagination);
    }

    _setNoResults(noResults) {
        Utils.clearHtml(this.noResults);
        if (noResults) {
            Utils.insetContent(this.noResults, tmplNoResults());
        }
    }

    setFlatsList(premises, isReplace = false) {
        if (!premises || !premises.length) {
            return;
        }

        if (isReplace) {
            Utils.clearHtml(this.flatsList);
        }

        if (this.wrapper.dataset.type === 'parking') {
            Utils.insetContent(this.flatsList, tmplParkingList({premises}));
            const popupLinks = Array.from(this.element.querySelectorAll('.j-popup-callback'));

            observer.publish('popup:refresh', popupLinks);
        } else if (this.wrapper.dataset.type === 'pantry') {
            Utils.insetContent(this.flatsList, tmplPantryist({premises}));
            const popupLinks = Array.from(this.element.querySelectorAll('.j-popup-callback'));

            observer.publish('popup:refresh', popupLinks);
        } else {
            Utils.insetContent(this.flatsList, tmplFlatsList({premises}));
        }

        this._bindCardsEvents();
        observer.publish('parametric:updateFlats', this);
    }

    /**
     * Устанавливает новые данные в блок "Показать ещё"
     * @param {Object} pagination - объект с данными о количестве квартир
     */
    setMoreButton(pagination) {
        if (!this.moreButton) {
            return;
        }

        this.page = pagination.page;

        this.moreButton.classList.toggle('is-hidden', this.page === pagination.pages);

        if (pagination) {
            this.moreButton.dataset.shown = pagination.limit;
        }
    }

    /**
     * Дополняет список квартир (Показать ещё)
     * @param {object} data - данные с сервера
     */
    setMoreResult(data) {
        this.setFlatsList(data.premises, false);
        this.setMoreButton(data.pagination);
    }

    scrollToTop() {
        this.element.scrollIntoView({
            behavior: 'smooth'
        });
    }

    _bindContext() {
        this._showMore = this._showMore.bind(this);
        this._collectData = this._collectData.bind(this);
    }

    /**
     * Инициализация элементов выдачи
     * @private
     */
    _initElements() {
        this.wrapper = document.querySelector('.j-parametric');
        // Враппер со списком квартир
        this.flatsList = this.element.querySelector('.j-parametric-result__content');
        // Кнопка "Показать все варианты"
        this.resetBtn = this.element.querySelector('.j-parametric-result__reset');
        // Инпуты сортировки
        this.sortInputs = Array.from(this.wrapper?.querySelectorAll('.j-parametric-result__sort input'));

        const sortDefault = this.sortInputs.find((item) => {
            return item.checked;
        });

        this.sort = sortDefault ? sortDefault.dataset.sort : null;
        this.order = sortDefault ? sortDefault.value : null;

        // Показать ещё
        this.moreButton = this.element.querySelector('.j-parametric-result__more');

        // Враппер отсутствия результатов
        this.noResults = this.element.querySelector('.j-parametric-result__nothing');
    }

    _initSelects() {
        this.selectElements = Array.from(this.wrapper?.querySelectorAll('.j-parametric-result__sort'));
        this.selects = [];
        this.selectElements.forEach((elem) => {
            const select = new CustomSelect({
                element: elem
            });

            select.init();
            this.selects.push(select);
        });
    }

    /**
     * Отправляет данные на сервер
     * @param {String} type - тип отправки
     * @param {Object} data - данные для отправки
     * @private
     */
    _send(type, data = {}) {
        if (!type) {
            return;
        }

        switch (type) {
            case 'sort':
                if (this.options.changeSort) {
                    this.options.changeSort(data);
                }
                break;
            case 'pagination':
                if (this.options.clickMore) {
                    this.options.clickMore(data);
                }
                break;
            default:
                break;
        }
    }

    _bindEvents() {
        this.sortInputs.forEach((sortInput) => {
            sortInput.addEventListener('change', (event) => {
                this.sort = event.target.value;
                this._send('sort', {});
            });
        });

        if (this.moreButton) {
            this.moreButton.addEventListener('click', this._showMore);
        }

        this._bindCardsEvents();
    }

    _bindCardsEvents() {
        const showMoreButtons =
            Array.from(this.element.querySelectorAll('.j-parametric-card__show-more:not([data-init])'));

        showMoreButtons.forEach((showMoreBtn) => {
            showMoreBtn.addEventListener('click', (event) => {
                event.preventDefault();
            });
            showMoreBtn.setAttribute('data-init', 'true');
        });
    }

    /**
     * Показать ещё
     * @private
     */
    _showMore() {
        this._send('pagination', this._collectData());
    }

    _collectData() {
        const data = {};

        this._addLimit(data);
        this._addPage(data);

        return data;
    }

    /**
     * Добавляет количество выведенных квартир в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addLimit(data) {
        if (!this.moreButton) {
            return;
        }

        data.shown = this.moreButton.dataset.shown;
    }

    /**
     * Добавляет количество подруженных страниц
     * @param {Object} data - объект данных
     * @private
     */
    _addPage(data) {
        if (!this.moreButton) {
            return;
        }

        this.page = this.page + 1;
        data.page = this.page;
    }
}

export default ParametricResult;
